export interface CampanhaBackoffice {
  id: string;
  empresaId: string;
  nome: string;
  tipo: 'vendas' | 'performance' | 'aquisicao' | 'capacitacao' | 'engajamento';
  status: 'rascunho' | 'programada' | 'ativa' | 'pausada' | 'finalizada';
  dataInicio: string;
  dataFim: string;
  participantesAtivos: number;
  participantesTotal: number;
  pontosDisponiveis: number;
  pontosDistribuidos: number;
  faturamentoMensal: number;
  responsavel: string;
}

export const campanhasBackoffice: CampanhaBackoffice[] = [
  {
    id: 'CAMP-001',
    empresaId: 'EMP-001',
    nome: 'Vendas Q1 2026',
    tipo: 'vendas',
    status: 'ativa',
    dataInicio: '2026-01-01',
    dataFim: '2026-03-31',
    participantesAtivos: 320,
    participantesTotal: 400,
    pontosDisponiveis: 125000,
    pontosDistribuidos: 87500,
    faturamentoMensal: 45000,
    responsavel: 'João Silva',
  },
  {
    id: 'CAMP-002',
    empresaId: 'EMP-001',
    nome: 'Performance Abril',
    tipo: 'performance',
    status: 'ativa',
    dataInicio: '2026-04-01',
    dataFim: '2026-04-30',
    participantesAtivos: 280,
    participantesTotal: 400,
    pontosDisponiveis: 60000,
    pontosDistribuidos: 32000,
    faturamentoMensal: 18000,
    responsavel: 'Maria Santos',
  },
  {
    id: 'CAMP-003',
    empresaId: 'EMP-002',
    nome: 'Captação de Clientes',
    tipo: 'aquisicao',
    status: 'ativa',
    dataInicio: '2026-03-01',
    dataFim: '2026-06-30',
    participantesAtivos: 120,
    participantesTotal: 200,
    pontosDisponiveis: 45000,
    pontosDistribuidos: 28000,
    faturamentoMensal: 12000,
    responsavel: 'Carlos Oliveira',
  },
  {
    id: 'CAMP-004',
    empresaId: 'EMP-003',
    nome: 'Capacitação Q2',
    tipo: 'capacitacao',
    status: 'ativa',
    dataInicio: '2026-04-01',
    dataFim: '2026-06-30',
    participantesAtivos: 180,
    participantesTotal: 234,
    pontosDisponiveis: 30000,
    pontosDistribuidos: 12000,
    faturamentoMensal: 8000,
    responsavel: 'Ana Costa',
  },
  {
    id: 'CAMP-005',
    empresaId: 'EMP-002',
    nome: 'Engajamento Trimestral',
    tipo: 'engajamento',
    status: 'programada',
    dataInicio: '2026-06-01',
    dataFim: '2026-08-31',
    participantesAtivos: 0,
    participantesTotal: 0,
    pontosDisponiveis: 80000,
    pontosDistribuidos: 0,
    faturamentoMensal: 0,
    responsavel: 'Pedro Lima',
  },
  {
    id: 'CAMP-006',
    empresaId: 'EMP-004',
    nome: 'Vendas Produto Novo',
    tipo: 'vendas',
    status: 'rascunho',
    dataInicio: '2026-05-15',
    dataFim: '2026-07-15',
    participantesAtivos: 0,
    participantesTotal: 0,
    pontosDisponiveis: 20000,
    pontosDistribuidos: 0,
    faturamentoMensal: 0,
    responsavel: 'Paulo Henrique',
  },
  {
    id: 'CAMP-007',
    empresaId: 'EMP-001',
    nome: 'Fidelização Clientes',
    tipo: 'engajamento',
    status: 'finalizada',
    dataInicio: '2025-10-01',
    dataFim: '2025-12-31',
    participantesAtivos: 0,
    participantesTotal: 350,
    pontosDisponiveis: 0,
    pontosDistribuidos: 98000,
    faturamentoMensal: 0,
    responsavel: 'Fernanda Costa',
  },
];

export function getStatusColor(status: string): string {
  switch (status) {
    case 'ativa': return 'bg-emerald-100 text-emerald-700';
    case 'programada': return 'bg-blue-100 text-blue-700';
    case 'pausada': return 'bg-amber-100 text-amber-700';
    case 'finalizada': return 'bg-gray-100 text-gray-700';
    case 'rascunho': return 'bg-stone-100 text-stone-700';
    default: return 'bg-gray-100 text-gray-600';
  }
}

export function getStatusLabel(status: string): string {
  switch (status) {
    case 'ativa': return 'Ativa';
    case 'programada': return 'Programada';
    case 'pausada': return 'Pausada';
    case 'finalizada': return 'Finalizada';
    case 'rascunho': return 'Rascunho';
    default: return status;
  }
}

export function getTipoLabel(tipo: string): string {
  switch (tipo) {
    case 'vendas': return 'Vendas';
    case 'performance': return 'Performance';
    case 'aquisicao': return 'Aquisição';
    case 'capacitacao': return 'Capacitação';
    case 'engajamento': return 'Engajamento';
    default: return tipo;
  }
}

export function getTipoColor(tipo: string): string {
  switch (tipo) {
    case 'vendas': return 'bg-emerald-100 text-emerald-700';
    case 'performance': return 'bg-orange-100 text-orange-700';
    case 'aquisicao': return 'bg-blue-100 text-blue-700';
    case 'capacitacao': return 'bg-purple-100 text-purple-700';
    case 'engajamento': return 'bg-teal-100 text-teal-700';
    default: return 'bg-gray-100 text-gray-600';
  }
}